import React from "react"
import { Header } from "semantic-ui-react"

import SelectToposProtimisis from "./SelectToposProtimisis"

const Positions = (props) => {
  const {
    perifereies,
    logoiMetathesis,
    errors,
    onChange,
    clearValues,
    epithymiaMetathesis,
    selectedPerifereiaA,
    selectedDimosA,
    selectedLogosA,
    selectedPerifereiaB,
    selectedDimosB,
    selectedLogosB,
    selectedPerifereiaC,
    selectedDimosC,
    selectedLogosC
  } = props
  return (
    <>
      <Header size="tiny">Επιλογή τόπου προτίμησης</Header>
      <SelectToposProtimisis
        error={errors.a}
        label="Επιλογή Α"
        choice="A"
        perifereies={perifereies}
        logoiMetathesis={logoiMetathesis}
        epithymiaMetathesis={epithymiaMetathesis}
        selectedPerifereia={selectedPerifereiaA}
        selectedDimos={selectedDimosA}
        selectedLogos={selectedLogosA}
        onChange={onChange}
        clearValues={clearValues}
        otherSelectedDimoi={[selectedDimosB, selectedDimosC]}
      />
      <SelectToposProtimisis
        error={errors.b}
        label="Επιλογή B"
        choice="B"
        perifereies={perifereies}
        logoiMetathesis={logoiMetathesis}
        epithymiaMetathesis={true}
        selectedPerifereia={selectedPerifereiaB}
        selectedDimos={selectedDimosB}
        selectedLogos={selectedLogosB}
        onChange={onChange}
        clearValues={clearValues}
        otherSelectedDimoi={[selectedDimosA, selectedDimosC]}
      />
      <SelectToposProtimisis
        error={errors.c}
        label="Επιλογή Γ"
        choice="C"
        perifereies={perifereies}
        logoiMetathesis={logoiMetathesis}
        epithymiaMetathesis={true}
        selectedPerifereia={selectedPerifereiaC}
        selectedDimos={selectedDimosC}
        selectedLogos={selectedLogosC}
        onChange={onChange}
        clearValues={clearValues}
        otherSelectedDimoi={[selectedDimosA, selectedDimosB]}
      />
    </>
  )
}

export default Positions
